import { RouteObject } from "react-router-dom";
import { ProjectsDevelopmentsPage } from "src/routes/projects/ProjectsDevelopmentsPage";
import { AppShell } from "src/routing/components/AppShell";
import { BeamNavbarLayout } from "src/routing/components/layouts/BeamNavbarLayout";
import { developmentsRoute, projectsRoute } from "src/routing/domains/projectsPaths";

/**
 * `/projects` and `/developments` list pages.
 *
 * Role: data router domain route.
 *
 * Stack: `AppShell` → `BeamNavbarLayout` → `ProjectsDevelopmentsPage`.
 * Do not nest `ScrollableParentLayout` here — that layout is legacy-only (see `src/routing/README.md`).
 * Path constants live in `projectsPaths.ts` (imported by `RouteUrls.ts` / pages) to avoid a cycle
 * through this file's page `Component` imports.
 * Legacy `Routes.tsx` must not register these paths.
 */
const listPageLayout: RouteObject = {
  Component: BeamNavbarLayout,
  children: [{ index: true, Component: ProjectsDevelopmentsPage }],
};

const projectsListRoute: RouteObject = { path: projectsRoute.path, Component: AppShell, children: [listPageLayout] };

const developmentsListRoute: RouteObject = {
  path: developmentsRoute.path,
  Component: AppShell,
  children: [listPageLayout],
};

export const projectsDevelopmentsRoutes: RouteObject[] = [projectsListRoute, developmentsListRoute];
